import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { ATeamStatus } from "@src/appV2/FeatureFlags/CbhFeatureFlags";

export function useGetATeamConfig() {
  const { status, isATeamOffExperimentEnabled, isShiftFeedbackEnabled } = useCbhFlag(
    CbhFeatureFlag.A_TEAM_CONFIG,
    {
      defaultValue: { status: ATeamStatus.ON },
    }
  );
  const isATeamEnabled = status === ATeamStatus.ON;
  const isATeamPhaseOut = isATeamOffExperimentEnabled ?? status === ATeamStatus.PHASE_OUT;

  return {
    isATeamEnabled,
    isATeamPhaseOut,
    isShiftFeedbackEnabled,
  };
}
